(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const containers = document.querySelectorAll("[data-quick-variant-link]");
    if (!containers.length) return;

    containers.forEach(container => {

      /* Resolve URL uma única vez */
      const productUrl =
        container.querySelector("[data-product-url]")?.dataset.productUrl ||
        container.closest(".product-card")
          ?.querySelector(".product-card__link")
          ?.href;

      if (!productUrl) return;

      /* Remove dropdowns apenas se existirem */
      container
        .querySelectorAll(".quick-variant-dropdown")
        .forEach(d => d.remove());

      /* Cursor pointer direto no container */
      container.style.cursor = "pointer";

      /* Delegação única */
      container.addEventListener("click", (e) => {
        const clickable = e.target.closest(
          ".quick-variant-trigger, .quick-variant-icon, .quick-variant-price, .quick-variant-label, .quick-variant-value"
        );

        if (!clickable) return;

        window.location.assign(productUrl);
      });

    });
  });
})();
